import { SVGProps } from 'react';

const CandyCane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.75 7 15 2.1m-4.1 2.7L13 9m-5.1.7 2 4.4m-5 .6L7 18.9M5.7 21a2.016 2.016 0 0 1-3.5-2l8.6-14a6.004 6.004 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2z"
    />
  </svg>
);
export default CandyCane;
